var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',[_c('div',{staticClass:"container-fluid breadcrumb-bar"},[_c('div',{staticClass:"container"},[_c('b-breadcrumb',{attrs:{"items":_vm.breadcrumb}})],1)])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }